import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import { useAppTheme } from '../../../context/theme.context';

const ThemeToggle = ({ sx = {} }) => {
  const { isDark, setThemeMode } = useAppTheme();

  const handleToggle = () => {
    setThemeMode(isDark ? 'light' : 'dark');
  };

  return (
    <Tooltip title={isDark ? 'Modo claro' : 'Modo oscuro'}>
      <IconButton
        onClick={handleToggle}
        color="inherit"
        aria-label="Cambiar tema"
        sx={{
          transition: 'all 0.3s ease',
          '&:hover': {
            backgroundColor: 'rgba(255,255,255,0.1)',
            transform: 'rotate(30deg)',
          },
          ...sx,
        }}
      >
        {isDark ? (
          <LightModeIcon sx={{ fontSize: 22 }} />
        ) : (
          <DarkModeIcon sx={{ fontSize: 22 }} />
        )}
      </IconButton>
    </Tooltip>
  );
};

export default ThemeToggle;
